import React, { FC } from 'react';
import { Alert } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { useWatch } from 'react-hook-form';
import { Page } from '@/declarations/models/Page';
import { pageHasMainHeading } from './pageMainHeading';

/** Pages without a main heading (h1) are harder to find and to navigate with a screen reader. */
export const MissingMainHeadingWarning: FC = () => {
  const { t } = useTranslation('components');
  const sections = useWatch<Page, 'content.sections'>({ name: 'content.sections' });
  const pageTitle = useWatch<Page, 'title'>({ name: 'title' });

  if (pageHasMainHeading(sections ?? [], pageTitle)) return null;
  return (
    <Alert severity='warning' sx={{ mx: 2, my: 1 }}>
      {t('PageEditor.missingMainHeadingWarning')}
    </Alert>
  );
};

export default MissingMainHeadingWarning;
